<template>
  <div
    v-if="isRequired"
    :id="`cta-card-v2-${randomId}`"
    :data-testid="dataTestid"
    :class="
      props.class ||
      twMerge('flex items-center justify-center gap-2 flex-col md:flex-row', appendClass)
    "
  >
    <slot name="content">
      <TsTypography
        v-if="content"
        append-class="text-center lg:text-left mb-0 font-bold shrink max-md:mb-2 md:mr-2 text-idle-black"
      >
        {{ content }}
      </TsTypography>
    </slot>

    <div class="flex gap-2 min-w-max">
      <slot name="cta-buttons">
        <!-- APPLE STORE -->
        <NuxtLink
          v-if="appleStoreImage || appleStoreLink"
          :to="appleStoreLink"
          target="_blank"
          :data-testid="`${dataTestid}-apple-cta`"
          class="cursor-pointer"
          @click="logDownload('App Store')"
        >
          <TsImage
            :src="appleStoreImage ?? ''"
            alt="Download on the App Store"
            loading="lazy"
            class="h-12 w-auto"
          />
        </NuxtLink>

        <!-- GOOGLE PLAY -->
        <NuxtLink
          v-if="googleStoreImage || googlePlayStoreLink"
          :to="googlePlayStoreLink"
          target="_blank"
          :data-testid="`${dataTestid}-google-cta`"
          class="cursor-pointer"
          @click="logDownload('Google Play')"
        >
          <TsImage
            :src="googleStoreImage ?? ''"
            alt="Get it on Google Play"
            loading="lazy"
            class="h-12 w-auto"
          />
        </NuxtLink>
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { twMerge } from 'tailwind-merge';
import { useRandomUUID } from '~/composables/useRandomUUID';

type Props = {
  content?: string;
  isRequired?: boolean;
  appleStoreImage?: string;
  appleStoreLink?: string;

  googleStoreImage?: string;
  googlePlayStoreLink?: string;

  appendClass?: string;
  class?: string;
  dataTestid?: string;
};

const props = defineProps<Props>();

const {
  isRequired,
  content,
  appleStoreImage,
  appleStoreLink,
  googleStoreImage,
  googlePlayStoreLink,
  appendClass,
  dataTestid = 'card-cta-v2',
} = props;

const randomId = ref('');

onMounted(() => {
  randomId.value = useRandomUUID();
});

onBeforeUnmount(() => {
  randomId.value = '';
});

const logDownload = (platform: string) => {
  logEvent({
    options: {
      eventAction: 'click',
      eventProperties: {
        platform,
      },
      eventInteraction: true,
      eventLabel: `user tried download from ${platform}`,
      eventName: 'trackDownloadApp',
    },
  });
};
</script>
